import { supabase } from '../../shared/supabase/supabaseClient';
import { createKeyedTtlCache } from '../../shared/data/keyedTtlCache';
import { clearBootstrapSessionCache } from './bootstrapMobileSessionService';
import { clearSessionOrganizationCache } from './sessionOrganization';
import { SESSION_CACHE_MS } from './sessionCacheTtl';
import {
  parseListMyOrganizationsPayload,
  type ListMyOrganizationsPayload,
  type UserOrganizationSummary,
} from './organizationsPayload';

export type { ListMyOrganizationsPayload, UserOrganizationSummary };

/**
 * La lista de orgs viene embebida en `bootstrap_mobile_session` desde
 * 20262024200000 — el pill/sidebar leen el cache primado por hydrate en vez de
 * repetir la RPC. Lectores interactivos (sheet, post-onboarding) fuerzan.
 */
const orgsCache = createKeyedTtlCache(SESSION_CACHE_MS);

export function primeMyOrganizationsCache(payload: ListMyOrganizationsPayload | null): void {
  orgsCache.set('_', payload);
}

async function fetchRemoteMyOrganizations(): Promise<ListMyOrganizationsPayload | null> {
  const { data, error } = await supabase.rpc('list_my_organizations');
  if (error) {
    console.warn('[organizationSwitcher] list_my_organizations failed', error.message);
    return null;
  }
  return parseListMyOrganizationsPayload(data);
}

export async function fetchMyOrganizations(opts?: {
  force?: boolean;
}): Promise<ListMyOrganizationsPayload | null> {
  return orgsCache.get('_', fetchRemoteMyOrganizations, { force: opts?.force });
}

export async function setActiveOrganization(organizationId: string): Promise<ListMyOrganizationsPayload | null> {
  const { data, error } = await supabase.rpc('set_active_organization', {
    p_organization_id: organizationId,
  });
  if (error) {
    console.warn('[organizationSwitcher] set_active_organization failed', error.message);
    return null;
  }
  clearBootstrapSessionCache();
  clearSessionOrganizationCache();
  const parsed = parseListMyOrganizationsPayload(data);
  orgsCache.set('_', parsed);
  return parsed;
}
